import { StrapiArticleCondensedResponse } from "@/shared/types/strapi/collections/article";
import React, { useState } from "react";
import plusIcon from "public/img/icons/sprite/plus.svg";
import minusIcon from "public/img/icons/sprite/minus.svg";
import arrowRightIcon from "public/img/icons/sprite/arrow-right.svg";
import s from "./ArticleCategories.module.scss";
import cn from "classnames";
import { TOTAL_PREVIEW_ARTICLES_IN_CATEGORY } from "@/shared/config/constants";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import { Link } from "@/components/pages/blog/ai-article/components/Link";

type ArticleCategoryItemProps = {
  idCategory: number;
  categorySlug: string;
  title: string;
  articlesData?: StrapiArticleCondensedResponse;
  initiallyOpen?: boolean;
  articleSlug?: string;
  onOpen: (idCategory: number) => void;
  onShowAll: (idCategory: number) => void;
  hasArticles?: boolean;
};

export const ArticleCategoryItem = ({
  initiallyOpen,
  title,
  articlesData,
  categorySlug,
  articleSlug,
  onOpen,
  idCategory,
  onShowAll,
  hasArticles,
}: ArticleCategoryItemProps) => {
  const [isOpen, setOpen] = useState(!!initiallyOpen);

  const articles = (articlesData?.data || []).sort(
    (a, b) => (a.attributes.displayOrder || 0) - (b.attributes.displayOrder || 0)
  );

  const handleClick = () => {
    setOpen(!isOpen);
    if (isOpen) return;
    // going to open
    if (!articlesData) {
      onOpen(idCategory);
    }
  };

  const totalArticlesInCategory = articlesData?.meta.pagination.total || 0;

  return (
    <li
      className={cn(s.articleCategoryItem, {
        [s.isOpen]: isOpen,
      })}
    >
      <span className={s.articleCategory}>
        <SpriteIcon
          icon={isOpen ? minusIcon : plusIcon}
          width={20}
          height={20}
          style={
            hasArticles
              ? {}
              : {
                  visibility: "hidden",
                  pointerEvents: "none",
                }
          }
          className={s.toggleIcon}
          onClick={handleClick}
        />{" "}
        <Link href={`/${categorySlug}`} className={s.articleCategoryLink}>
          {title}
          <SpriteIcon icon={arrowRightIcon} className={s.iconArrow} />
        </Link>
      </span>
      {!!articles.length && isOpen && (
        <>
          <ul>
            {articles.map(({ id, attributes: { slug, heading, sidebarTitle } }) => (
              <li key={id}>
                <Link href={`/${categorySlug}/${slug}`} className={cn({ [s.active]: articleSlug === slug })}>
                  {sidebarTitle || heading}
                </Link>
              </li>
            ))}
          </ul>
          {totalArticlesInCategory > TOTAL_PREVIEW_ARTICLES_IN_CATEGORY && (
            <div className={s.linkWrap}>
              <button
                type="button"
                className={s.link}
                onClick={() => {
                  onShowAll(idCategory);
                }}
              >
                Show all ({totalArticlesInCategory}){" "}
                <SpriteIcon width={20} height={20} icon={arrowRightIcon} />
              </button>
            </div>
          )}
        </>
      )}
    </li>
  );
};
